export enum Path {
  HOME = "/",
  ABOUT = "/about",
  ARTS = "/arts",
  ARTWORK_DETAILS = "/artwork-details",
  CONTACT = "/contact",
  LOGIN = "/login",
  REGISTER = "/register",
  FORGOT_PASSWORD = "/forgot-password",
  RESET_PASSWORD = "/reset-password",
  VERIFY_EMAIL = "/verify-email/:token",
  USERS = "/users",
  CATEGORIES = "/categories",
  ARTWORKS = "/artworks",
  SITE_CONTENTS = "/site-contents",
}
